import { RoomType } from "@eisox/api/core-api";

export const AVAILABLE_ROOM_TYPES = [
  RoomType.OFFICE,
  RoomType.CORRIDOR,
  RoomType.KITCHEN,
  RoomType.TOILET,
  RoomType.ROOM,
] as const;
